import { getFromCookie } from './cookie'
import { getParamCaseInsensitive } from './params'
import type { Config } from 'type/app'

export const utmList = [
  'utm_source',
  'utm_term',
  'utm_campaign',
  'utm_content',
  'utm_medium',
] as const

export const getUtmValue = (
  utm: (typeof utmList)[number],
  queryParams: URLSearchParams,
  config?: Config,
): string | undefined => {
  if (config) {
    if (config.utm) return config.utm[utm]
    return undefined
  } else {
    const value = getParamCaseInsensitive(queryParams, utm) ?? getFromCookie(utm)
    if (value === 'undefined') {
      return undefined
    }
    return value
  }
}

export const getUtmsFromQueryParams = (
  queryParams: URLSearchParams,
  config?: Config,
): Record<string, string> => {
  const utms: Record<string, string> = {}
  for (const utm of utmList) {
    const value = getUtmValue(utm, queryParams, config)
    if (value) utms[utm] = value
  }
  return utms
}
